export default {
    site: {
        common: {
            hello: "Ahoj",
            thankYou: "Díky",
            forMoreInfo: "pro více informací",
            hoverOverColumnHeaders: "Pro více informací najeďte kurzorem na nadpis sloupce.",
            username: "jméno hráče",
            score: "Skóre",
            points: "Body",
            pointsAbbreviation: "b",
            chapter: "Kapitola",
            tier: "Úroveň",
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Sběrů za den",
            relicBoostPercent: "% z relikvií",
            mountainHallPercentShort: "Horské S. %", // used in table heading keep it short.
            updated: "aktualizováno",
            lastUpdated: "Naposledy aktualizováno",
            created: "vytvořeno",
            role: "role",
            Fellow: 'Člen',
            Ambassador: 'Velvyslanec',
            Mage: 'Zástupce velitele',
            Archmage: 'Velitel',
            saveChanges: "Uložit změny",
            copy: "Kopírovat",
            close: "Zavřít",
            cancel: "Zrušit",
            action: "Akce",
            date: "Datum",
            Left: "Odešel",
            Joined: "Přidal se",
            human: "Člověk",
            elf: "Elf",
            search: "Vyhledávání",
            enter: "Zadej",
            yes: "Ano",
            no: "Ne",
            tournament: "Turnaj",
            tournaments: "Turnaje",
            fellowship: "Spolek",
            player: "Hráč",
            member: "Člen",
            history: "Historie",
            tournamentHistory:  "Historie turnaje",
            scoreHistory: "Historie skóre",
            server: "Herní svět",
            lastWeekGain: "Zisk za poslední týden",
            comingSoon: "Již brzy",
            chest: "truhla",
            yourServer: "Tvůj herní svět",
            allServers: "Všechny herní světy",
            boosts: "Bonusy",
            marble: "mramor",
            steel: "ocel",
            planks: "prkna",
            crystal: "křišťál",
            scrolls: "svitky",
            silk: "hedvábí",
            elixir: "elixír",
            magic_dust: "kouzelný prach",
            gems: "drahokamy",
            sentient: "živoucí",
            goods: "zboží",
            average: "průměr",
            expansions: 'Rozšíření', // 5x5 grids
            cultureBoostMinimum: 'Minimální kulturní bonus',
            cultureBoostCalculated: 'Vypočtený kulturní bonus',
            neighborlyHelp: 'Sousedská výpomoc',
            neighborlyHelpAbbreviation: 'SV'
        },
        // HIGH PRIORITY
        nav: {
            home: "Domů",
            players: "Hráči",
            fellowships: "Spolky",
            tournaments: "Turnaje",
            contact: "Kontakt",
            donate: "Přispějte",
            faq: "FAQ",
            news: "Novinky",
            privacyPolicy: "Ochrana osobních údajů",
            me: "Já",
            myFellowship: "Můj spolek",

            // NOTE USED AT THE MOMENT
            globalStats: "Globální statistiky",
            articles: "Články",
            fellowshipAdventure: "Dobrodružství společenství",
            recruit: "Nábor",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Zobrazit město v Elven Architectu"
            ,obtainingLink: "Načítám odkaz"
            ,successMessage: "Podařilo se! Klikněte na odkaz níže pro otevření Elven Arichtekta"
            ,ageOfLink: "Odkaz výše načte město jak vypadalo k: "
            ,clickToGetCurrentCity: "<-- Klikněte sem pro načtení aktuálního stavu města",
        },
        // High Priority
        playerSelection: {
            headline: "Prohlížet stránky jako",
            description: "Přihlášení aktualizuje některé části stránek tak, aby odpovídali přihlášenému hráči. Jedná se například o stránky: můj spolek, můj účet, turnaje, či hodnocení.",
            youAreViewing: "Nyní prohlížíte stránky jako {username} ze světa {serverName}.",
            changeUser: "Změnit hráče",
            enterYourUsernameToGetStarted: "Pro zahájení vložte své herní jméno z Elvenaru",
            thisIsNotASignup:"Nejedná se o standardní proces přihlášení. Po vložení Vašeho herního jména pouze adekvátně upravíme obsah stránek. Je mnoho herních světů Elvenaru, zadáním jména se zaměříme na ten Váš. Po zadání jména budou též dostupné stránky o Vašem spolku a Vašem účtu."
        },
        searchBoxes: {
            enterFellowshipName: 'Zadej jméno spolku',
            instructions: "Napiš část jména a pak vyber ze seznamu.",
            noFellowship: "Žádný spolek",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dnů zpět",
            minsAgo: "minut zpět",
            hoursAgo: "hodin zpět",
            justNow: "nyní",
            never: "nikdy",
        },
        home: {
            welcome: "Vítejte na Elven Stats!",
            youAreViewing: "Nyní si prohlížíte stránky jako hráč {username} na serveru {serverName}",
            youCanChange: "Změnu hráče můžete provést kliknutím na avatara v pravém horním rohu -nebo- <router-link to='/contact'>navštívením této stránky</router-link>",
            features: {
                headline: "Funkce",
                fellowshipAdministration: {
                    headline: "<strong>MNOHEM SNAZŠÍ</strong> administrace spolků",
                    bullet1: "Automatické vyhledání bonusů jednotlivých členů spolku, pro pomoc s vyvážením Vašeho spolku",
                    bullet2: "Automatické generování týdenních reportů zahrnujících body, účast v turnajích, měsíční růst, či osobní rekordy",
                    bullet3: "Pomoc s identifikací nevyrovnaností ve výrobě jednotlivých členů cechu, například u zásob, nebo zboží jednotlivých stupňů",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Integrace</strong> ElvenArchitecta",
                    description: "Načtěte své aktuální město přímo do ElvenArchitektu během pár vteřin! Tuto volbu můžete využít pro lepší plánování Vaší příští větší reorganizace, nebo k nalezení volného místa, které jste ani netušili, že ve městě ještě máte. Pro použití funkce hledejte logo ElvenArchitekta na stránce Vašeho účtu(JÁ)."
                },
                advancedRankingLists: {
                    headline: "Rozšířený <strong>Žebříček</strong>",
                    bullet1: "Žebříček dle prozkoumaných oblastí (pro porovnání s ostatními hráči ve stejné fázi hry)",
                    bullet2: "Zobrazení bonusů, aktuální kapitoly, a dalších údajů v žebříčku hráčů.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Sledování</strong> turnajů dle spolků",
                    description: "Podívejte se, jak si Váš spolek stojí v porovnání s ostatními. Vyzvěte jiné spolky na přátelský duel!",
                },
                matchMaking: {
                    headline: "<strong>Hledání</strong> shody",
                    description: "ElvenStats vyhledává bonusy hráčů a schopnost produkce zboží v jednotlivých spolcích. Díky těmto informacím mohou spolky snadno zjistit, jaké ideální členy potřebují pro vybalancování spolku. Naopak, hráči hledající spolek mohou snáze najít takový , který skutečně využije jejich bonusů. Takto šetří čas, i případná odmítnutí!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Umístění",
                points: "Body",
                medianUserScore: "Průměrné <strong>skóre členů</strong>",
                memberCount: "<strong>Počet</strong> členů",
            },
            barCharts: {
                clickSlice: "Klikněte na sloupec pro detaily (dle členů)",
                tier1: "Úroveň 1",
                tier2: "Úroveň 2",
                tier3: "Úroveň 3",
                drillDown: "Zpět k {0}"
            },
            idealCandidate: {
                heading: "Ideální kandidát",
                description: "By měl mít skóre okolo {medianScore} a měl by mít jeden, nebo více, z následujících bonusů: {boosts}",
                note: "Některé kombinace bonusů nejsou ve hře možné. Kliněte sem {0}"
            },
            memberGoodsTable: {
                heading: "Produkce zboží dle členů",
                description: "Tato tabulka ukazuje výpočet, kolik od každého zboží který ze členů vyrábí. Počítáme s kvalifikovaným odhadem procentuálního bonusu každého člena cechu, a ve výchozím stavu počítáme u každého člena se 3 sběry za den (2x9h + 1x3h). Pro zlepšení přesnosti výpočtu, se poptejte svých členů na přesné procentuelní bonusy a počty sběrů za den, a vyplňte je do tabulky níže. Tyto hodnoty se uloží a můžete s nimi tedy pracovat při jakémkoli dalším otevření stránek, bez nutnosti je znovu zadávat. Sloupcové grafy výše budou automaticky upraveny ihned po zadání hodnot do tabulky. Pro více informací k jednotlivým sloupcům najeďte kurzorem na nadpis sloupce.",
                refreshButtonText: 'Obnov seznam členů',
                refreshButtonTip: 'Tato akce přidá nové členy, odebere ty staré, obnoví přehled rolí v cechu a aktualizuje aktuální skóre.',
                inactiveWarningTip: 'Hráč může být neaktivní, skóre naposledy aktualizováno: {0}',
                collectsPerDayValidation: "Číslo musí být v rozsahu 1-6",
                boostPercentValidation: "Číslo musí být v rozsahu 40 - 700, nezapočítávejte bonus z Horského sídla",
                perDayShort: "/den",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Skóre hráče, prosím, vemte v potaz že tato hodnota není aktualizována v reálném čase, pouze několikrát za týden.",
                chapterTip: "Kapitola, ve které se hráč aktuálně nachází. Pro příklad: Elementálové = 12, Půlčíci = 11, atd.",
                boostTip: "Zboží, na které má hráč bonus, a množství zboží, které VYROBÍ za den.",
                collectsPerDayTip: "***UPRAVITELNÉ*** <br/>Počet sběrů za den. Toto číslo vyjadřuje, kolikrát za den hráč vybírá ukončenou výrobu ze svých manufaktur. Mělo by jít o hodnotu v rozsahu 1 - 6, kde 1=1x24h, 2=2x9h, 3=2x9h + 1x3h, 4=1x9h + 3x3h, 5=4x3h + 1x9h, 6=5x3h + 1x9h<BR/>Pro více informací navštivte FAQ sekci.",
                relicBoostPercentTip: "***UPRAVITELNÉ***<br/>Procentuální bonus z relikvií, měl by být v rozsahu 40-700. Tento bonus nezahrnuje bonus z divu Horské sídlo - tento je automaticky detekován a přičítán k číslu v tomto sloupci.",
                mountainHallPercentTip: "Toto je bonus z divu Horské sídlo, který jsme detekovali u jednotlivých hráčů. Používá se v součtu s bonusem z relikvií k vypočtení celkového procentuálního bonusu hráče.",
                updatedTip: "Toto je termín, kdy bylo naposledy analyzováno město hráče. Během procesu analýzy jsou aktualizovány bonusy, získáván nákres města pro ElvenArchitekt, vypočítávána produkce, a další data. K analýze dochází v pravidelných intervalech, ale můžete data manuálně nechat analyzovat kliknutím na obnovovací tlačítko.",

            },
            coinsAndSuppliesTable: {
                heading: "Výroba mincí / zásob",
                description: `Klíčovým sloupcem je zde sloupec "Zůstatek zásob", který ukazuje, zda hráč vyprodukuje dostatek zásob, aby udržel své manufaktury v běhu 24/7. Využijte přepínače níže k započítání minimálního kulturního bonusu (bonus, kterého hráč dosáhne bez jediné sousedské výpomoci) a započítání počtu denních výběrů zboží (z tabulky výše, při vypnutí bude počítáno 1x24h výroba). Vypnutí obou může být užitečné pokud chcete ověřit, jak velký vliv hraje počet výrob manufaktur, nebo naopak kulturní bonus.
                Prosím, berte v potaz, že dosažení záporného zůstatku zásob (kolem 10%) je naprosto běžné. Existuje mnoho způsobů, jak mohou hráči podpořit svou výrobu zásob, jako sousedská výpomoc, využití kratších výrob (hodinové, 5 minutové, atd.), či využití kouzla Síla zásob. Zápornou hodnotu tedy berte jako "úvahu nad tím, co vše musíte denně dělat, abyste měli dostatek zásob".
                POZNÁMKA: V tuto chvíli není započtena rekrutace armády, pouze výroba zboží, takže mohou hráči mít nižší celkový denní zůstatek zásob.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Min. bonus %",
                made: "Výroba",
                used: "Spotřeba",
                left: "Zůstatek",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Kulturní bonus. DŮLEŽITÉ: Bonus je počítán BEZ JAKÉKOLI SOUSEDSKÉ VÝPOMOCI. Ve skutečnosti je tato hodnota často vyšší.",
                moneyComputedTip: "Množství mincí vyprodukované za den, včetně mincí z Prastarých divů produkujících mince",
                moneyUsedComputedTip: "Množství mincí spotřebované na výrobu zboží.",
                moneyRemainingComputedTip: "Mince výroba - Mince spotřeba, jedná se o zůstatek mincí, kladný nebo záporný, kterého hráč každý den dosáhne",
                suppliesComputedTip: "Množství zásob, které by hráč vyprodukoval, kdyby všechny dílny byly nastaveny na výrobu 1x24 plus zásoby z prastarých divů (nezapočítává bonusy setů).",
                suppliesUsedComputedTip: "Množství zásob spotřebované na výrobu zboží. NEJSOU ZAPOČÍTÁNY zásoby spotřebované pro rekrutování armády! Viz výše",
                suppliesRemainingComputedTip: "Zboží výroba - Zboží spotřeba, jedná se o zůstatek zásob, kladný nebo záporný, kterého hráč každý den dosáhne",
                manaTip: "Množství many vyprodukované za 24 hodin (nezahrnuje manu z Dračího opatství)",
            },
            popCultureTable: {
                heading: "Populace / Kultura - detaily",
                description: "Tato tabulka ukazuje přehled populace/kultury každého člena spolku. Pro více informací k jednotlivým sloupcům najeďte kurzorem na nadpis sloupce.",

                // Icon Sub-Headings
                minBoostPercent: "Min. bonus %",
                levels: "Úroveň divů",
                total: "Celkem",
                working: "Pracující",
                available: "K dispozici",
                required: "Vyžadovaná",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Celkový součet úrovní všech prastarých divů, které má hráč ve svém městě.",
                cultureBoostPercentTip: "Kulturní bonus. DŮLEŽITÉ: Bonus je počítán BEZ JAKÉKOLI SOUSEDSKÉ VÝPOMOCI. Ve skutečnosti je tato hodnota často vyšší.",
                totalPopulationTip: "Celková populace získaná z obytných budov, kulturně/obytných hybridních budov a prastarých divů",
                workingPopulationTip: "Pracující populace - Množství lidí využité budovami",
                availablePopulationTip: "Dostupná populace",
                totalCultureTip: "Celková kultura získaná z kulturních budov, kulturně/obytných hybridních budov a prastarých divů",
                requiredCultureTip: "Kultura potřebná pro všechny hráčovi budovy",
                availableCultureTip: "Volná kultura",
            },
            cityCoverageTable: {
                heading: "Pokrytí města",
                description: "Tabulka ukazuje, kolik políček, ve městě každého hráče, je využito pro jednotlivé typy budov. Volná políčka jsou políčka, na kterých aktuálně nestojí žádná budova.",
                tiles: 'Políčka'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Týdení report",
                description: "Automaticky generujeme týdenní reporty vhodné a předpřipravené pro sdílení s ostatními členy spolku. Nový týdenní report bude dostupný každou neděli (přibližně ve 22:00 letního času) za uplynulý týden. Stačí jednoduše zkopírovat a vložit!",
                selectReportHint: "Zobrazit report za týden končící k",
                reportsAreOptimizedFor: "Reporty jsou optimalizovány pro Elvenarský systém zpráv tak, že sloupce jsou co nejpřesněji zarovnány a uživatelská jména jsou ořezána tak, aby se report vešel do jedné zprávy.",
                accolades: "Ocenění:",
                tourneyChamp: " - Turnajový šampion (tento týden): {0}",
                tourneyHero: " - Turnajový hrdina (poslední 4 týdny): {0}",
                highestGrowthPlusPercentage: " - Největší nárůst (body & procenty): {0}",
                highestGrowthPoints: " - Největší nárůst (body): {0}",
                highestGrowthPercentage: " - Největší nárůst (procenta): {0}",
                highestGrowthError: " - Největší nárůst: Zatím nelze určit, je potřeba delší historie",
                newPersonalRecords: "Nové osobní rekordy",
                userSetANewPersonalRecordFor: " * {0} dosáhl nového osobního rekordu pro: {1}",
                allMembersByPointGainThisWeek: "VŠICHNI ČLENOVÉ spolku dle růstu bodů / procentuelně (tento týden)",
                tournamentPointsHeader: "TURNAJOVÉ body (tento týden / CELKEM OD {0})",
                top8ByPercentage: "TOP 8 dle procent (tento týden)",
                top8ByPointsSince: "TOP 8 dle bodů (od {0})",
                top8ByPercentageSince: "TOP 8 dle procent (od {0})",
                reportGeneratedBy: "Report vygenerován pomocí elvenstats.com, pro více informací: ",
                mostPointsInAWeek: "Největší bodový růst za týden",
                highestTournamentScore: "Nejvíce bodů v turnaji",
                highestTournamentRank: "Nejvyšší umístění v turnaji",
                insufficientHistoryForThesePlayers: "* Vynecháni: {0} pro nedostatečnou historii.  Budou zahrnuti v dalším týdnu",
                insufficientHistory1Week: "* Nedostatečná historie pro tuto sekci. Zkontrolujte další týden!",
                insufficientHistory4Weeks: "* Nedostatečná historie pro tuto sekci. Je potřeba alespoň 4 týdenní historie. Již brzy!",
            },
            memberHistory: {
                heading: "Historie členů",
                noChangesDetected: "Nejsou detekovány žádné pohyby členů spolku od počátku sledování k {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Máte neuložené změny. Prosím, po ukončení úprav Vašeho spolku klikněte na tlačítko Uložit',
                standbyImporting: 'Vydržte: Nahráváme chybějící data k některým členům Vašeho spolku',
                limitedHistory: "{0} jsme začali sledovat velmi nedávno, proto máme pouze omezenou historii. Každou neděli jsou načteny týdenní záznamy, vraťte se tedy brzy pro nová data!",
                noChangesSinceTrackingBegan: "Nejsou žádné změny od počátku sledování",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Historie spolků"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Okamžité aktualizace nejsou v tuto chvíli dostupné.",
            realTimeUpdatesNotAvailableDescription: "K tomuto stavu typicky dochází po restartu serverů Elvenaru například z důvodů aktualizace či údržby. Pokud k tomuto dojde, ElvenStats musí být manuálně připojen ke všem herním světům, aby mohly znovu být získávány informace. Prosím, opakujte svůj požadavek znovu za nějakou dobu (ideálně pár hodin). Ostatní funkce stránky by měly mezitím být stále běžně dostupné.",
            copyToClipboardSuccessful: "Uložení do Schránky bylo úspěšné!",
            copyToClipboardFailed: "Chyba při ukládání do schránky, označte celou oblast s textem a poté stiskněte CTRL+C",
            errorOccurredImporting: "Došlo k chybě, nahráváme uživatele.",
            errorOccurredImportingMessage: "Došlo k chybě při nahrávání vašich hráčů. Prosím, zkuste akci opakovat. Pokud se bude chyba opakovat, kontaktujte nás.",
            errorOccurredImportingWillNotBeAvailableInReports: "Hráči, kteří ještě nebyli importování, nejsou zahrnuti v reportech.",
            finishedSyncSuccessful: "Dokončeno, synchronizace byla úspěšná!",
            playerIsAnonymous: "Tento hráč si vyžádal, aby jeho informace nebyly zobrazovány na elvenstats.com",
            inactiveWarningTip: "Tento hráč může být neaktivní. K poslední změně skóre došlo k: {0}",
            isFriendTip: "Tento hráč je přítelem ElvenStats. Buďto přispěl na provoz stránek finančně, nebo svým časem!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/cs.js